angular.module('impactx.menubutton').directive('ixMenuButton', function () {
    return {
        scope: {
            options: '=',
            functionParams: '='
        },
        restrict: 'E',
        templateUrl: 'shared/menubutton/templates/menu-button.tmpl.html'
    }
});